export const RESUME_KEY = "rv.postLoginRedirect";

/**
 * True only for a same-origin internal path. Uses the URL parser (not prefix
 * checks) so it rejects absolute URLs, protocol-relative (`//evil`), backslash
 * tricks (`/\evil`), and embedded tab/CR/LF that would normalize to `//evil`.
 */
export function isSafeInternalPath(p: unknown): p is string {
  if (typeof p !== "string" || !p.startsWith("/")) return false;
  try {
    const url = new URL(p, window.location.origin);
    return url.origin === window.location.origin;
  } catch {
    return false;
  }
}

/** Resolve the post-login target: state.from -> stash -> "/". Always clears the stash. */
export function consumeResumeTarget(stateFrom: unknown): string {
  const stashed = sessionStorage.getItem(RESUME_KEY);
  sessionStorage.removeItem(RESUME_KEY); // clear on consume regardless of validity
  if (isSafeInternalPath(stateFrom)) return stateFrom;
  if (isSafeInternalPath(stashed)) return stashed;
  return "/";
}
